import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { onBasePath } from '../../paths/onBasePath';
import { NotFound } from '../NotFound';
import { path } from '../../paths';
import translations from './Tokens.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { TokenDirectory } from './TokenDirectory';

const { addTranslations, Translation } = i18nNsFactory('tokens');
addTranslations(translations);

const TOKEN_ROUTES = [
  {
    path: path.tokens,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.token')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <TokenDirectory />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const Tokens: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, TOKEN_ROUTES));
